export default __webpack_public_path__ + "static/thumb-landscape-38a862bb1f316d3161d8085befbecd48.jpg";